
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/category/[slug]",
      function () {
        return require("private-next-pages/[locale]/category/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/category/[slug]"])
      });
    }
  